import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useCommonApi } from '../../api';
import { onSuccessCustomApiResponse } from '../../api/utils';
import { useNotify } from '../../hooks';
import { AresResponse } from '../types/accident';

export const useLoadAresData = () => {
  const { notify } = useNotify();
  const [aresData, setAresData] = useState<AresResponse | undefined>(undefined);

  const { mutate: getAresData, isPending: isAresDataLoading } = useMutation(useCommonApi().getARESData());

  const handleLoadAresData = (vatNumber: string) => {
    getAresData(
      { vatNumber: vatNumber.replace(' ', '') },
      {
        onSuccess: onSuccessCustomApiResponse({
          executed: (_, data) => {
            if (data.code === 200) {
              setAresData(data);
            } else {
              notify('error', data.response.popis || 'Nepodařilo se získat data z ARES!');
            }
          }
        })
      }
    );
  };

  return { aresData, isAresDataLoading, handleLoadAresData };
};
